import React from 'react';
import Header from '../components/MainPage/Header';
import ProcessSection from '../components/MainPage/ProcessSection';
import AIPage from './AIPage';
import HardSkillsPage from './HardSkillsPage';
import CollaborationPage from './CollaborationPage';
import '../Landing.css';

const MainPage: React.FC = () => (
  <>
    <Header />
    <AIPage />
    <HardSkillsPage />
    <ProcessSection />
    <CollaborationPage />
  </>
);

export default MainPage;
